<template>
  <div class="card text-start p-0 shadow-sm mb-3 border-1 border-success">
    <div class="card-header bg-success-subtle border-success">
      <div class="fw-bold">Participants Data Export</div>
    </div>
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="my-auto fst-italic">{{ filename }}.csv</div>
        <button
          class="btn btn-sm btn-outline-success fw-bold"
          @click="exportToCSV()"
        >
          <i class="bi bi-download me-2"></i><span>Download</span>
        </button>
      </div>
    </div>
    <div class="card-footer p-0 pb-1 rounded-bottom">
      <div class="accordion accordion-flush" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              Export options
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              <div class="mb-3">
                <b>CSV Filename</b>
                <input type="text" class="form-control" v-model="filename" />
              </div>
              <div class="">
                <b>Column Headers</b>
                <div
                  class="d-flex justify-content-between"
                  v-for="header in columnHeaders"
                  :key="header"
                >
                  <div class="my-auto">{{ header }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/data/config";

export default {
  name: "AdminExport",
  props: {
    entries: Array
  },
  data() {
    return {
      filename: this.initFilename
    };
  },
  computed: {
    columnHeaders() {
      return Object.keys(this.entries[0]);
    }
  },
  methods: {
    objectToCSVRow(dataObject) {
      let dataArray = dataObject.map((datum) => {
        let value = datum === null ? "" : datum.toString();
        value = value.replace(/"/g, '""');
        value = value.replaceAll(",", ";");
        return value;
      });

      return dataArray.join(",") + "\r\n";
    },
    exportToCSV() {
      let arrayOfObjects = this.entries.map((object) => {
        if (object.value) {
          object.value = JSON.stringify(object.value);
        }
        return object;
      });
      if (!arrayOfObjects.length) {
        console.log("Cannot export. Invalid array", arrayOfObjects);
        return;
      }

      let csvContent = "data:text/csv;charset=utf-8,";

      const keys = Object.keys(arrayOfObjects[0]);
      /* Headers */
      csvContent += this.objectToCSVRow(keys);
      /* Content */

      arrayOfObjects.map((item) => {
        csvContent += this.objectToCSVRow(Object.values(item));
      });
      console.log(csvContent);

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${this.filename}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
      document.body.removeChild(link);
    },
    initFilename() {
      let name = import.meta.env.VITE_SEGMENT_KEY;
      console.log(name);
      const formatString = (value) => value.toLowerCase().replace(/[\s-]/, "");
      // Name file by class abbreviation and app title
      return `${formatString(name)}-${formatString(
        config.meta.title
      )}-user-data`;
    }
  },
  mounted() {
    this.filename = this.initFilename();
  }
};
</script>

<style scoped>
.accordion-button,
.accordion-button:not(.collapsed) {
  background: #21252908;
}
</style>
